import * as React from 'react';
import { Redirect, Route, RouteComponentProps, Switch } from 'react-router-dom';
import { VIEW_TYPE as AD_VIEW_TYPE } from './addata_constants';
import AdDataView from './AdDataView';

export type Props = RouteComponentProps;

/**
 * The root component for the /data route that manages the route URL state and filters
 */
export default class AdDataRouteManager extends React.Component<Props> {
  render() {
    const { match } = this.props;
    return (
      <Switch>
        <Route
          // @ts-ignore
          path={`${match.url}/:type(${AD_VIEW_TYPE.EVENT_CODE}|${AD_VIEW_TYPE.USER}|${AD_VIEW_TYPE.ORIGIN_USER}|${AD_VIEW_TYPE.DOMAIN})`}
          render={(routeProps) => (
            <AdDataView
              {...routeProps}
              // @ts-ignore
              type={routeProps.match.params.type}
              route={match.url}
            />
          )}
        />
        <Redirect to={`${match.url}/${AD_VIEW_TYPE.EVENT_CODE}`} />
      </Switch>
    );
  }
}
